//const 
const development = {
    endpoints: {
        customerApplications: 'https://xosz9sattg.execute-api.us-east-1.amazonaws.com/dev/appmanager/applications/authorized',
        dynatablesBackend: 'https://7b0978cbpg.execute-api.ap-northeast-1.amazonaws.com/dev'
    },

    // PureCloud assigned name for the premium app
    // This should match the integration type name of the Premium App
    // integrationType: "premium-app-dynatables",
    integrationType: "embedded-client-app",

    // Default Values for fail-safe/testing. Shouldn't have to be changed since the app
    // must be able to determine the environment from the query parameter 
    // of the integration's URL
    defaultPcEnv: "mypurecloud.com",
    //defaultPcEnv: "usw2.pure.cloud",
    defaultLangTag: "en-us",

    // Permissions required for running the Wizard App
    setupPermissionsRequired: ['admin'],

    // Application name
    appName: "Callflow Data Service Dev",

    // URL of the Callflow Data Service application
    //appUrl: "http://localhost:3000/",  
    appUrl: "https://d1983fp3djbgyw.cloudfront.net/",
    //appUrl: "https://dev-dynatables.genesyscsp.net/",

    // clientId of the Callflow Data Service application
    //clientId: 'd4dfa94d-d68a-417f-800c-baf332b178c1',
    clientId: "55605dc9-7aa2-4e49-809a-d93b7b35f51d", // US WEST    

    // These are the PureCloud items that will be added and provisioned by the wizard
    provisioningInfo: {
        "role": 
            {
                "name": "Role",
                "description": "Generated role for access to the app.",
                "permissionPolicies": [
                    {
                        "domain": "integration",
                        "entityName": "callflowDataService",
                        "actionSet": ["view"],
                        "allowConditions": false
                    },
                    {
                        "domain": "integrations",
                        "entityName": "integration",
                        "actionSet": ["view"],
                        "allowConditions": false
                    }
                ]
            }
        ,
        "oauth": 
            {
                "name": "OAuth Client",
                "description": "Generated Client that's passed to the App Backend",
                "roles": ["Role"],
                "authorizedGrantType": "CLIENT_CREDENTIALS"
            }
        
    }
};

const test = {
    endpoints: {
        customerApplications: 'https://xosz9sattg.execute-api.us-east-1.amazonaws.com/dev/appmanager/applications/authorized',
        dynatablesBackend: 'https://jkgq48ui3f.execute-api.us-east-1.amazonaws.com/test'
    },

    // PureCloud assigned name for the premium app
    // This should match the integration type name of the Premium App
    //integrationType: "premium-app-dynatables",
    integrationType: "premium-app-example",

    // Default Values for fail-safe/testing. Shouldn't have to be changed since the app
    // must be able to determine the environment from the query parameter 
    // of the integration's URL
    defaultPcEnv: "usw2.pure.cloud",
    defaultLangTag: "en-us",

    // Permissions required for running the Wizard App
    setupPermissionsRequired: ['admin'],

    // Application name
    appName: "Callflow Data Service QA",
    
    // URL of the Callflow Data Service application
    appUrl: "https://d2elimglfhjl3b.cloudfront.net/",
    //appUrl: "http://localhost:3000/",
    
    // clientId of the Callflow Data Service application
    clientId: 'd4dfa94d-d68a-417f-800c-baf332b178c1',
    //clientId: "55605dc9-7aa2-4e49-809a-d93b7b35f51d", // US WEST 
    
    // These are the PureCloud items that will be added and provisioned by the wizard
    provisioningInfo: {
        "role": 
            {
                "name": "Role",
                "description": "Generated role for access to the app.",
                "permissionPolicies": [
                    {
                        "domain": "integration",
                        "entityName": "callflowDataService",
                        "actionSet": ["view"],
                        "allowConditions": false
                    },
                    {
                        "domain": "integrations",
                        "entityName": "integration",
                        "actionSet": ["view"],
                        "allowConditions": false
                    }
                ]
            }
        ,
        "oauth": 
            {
                "name": "OAuth Client",
                "description": "Generated Client that's passed to the App Backend",
                "roles": ["Role"],
                "authorizedGrantType": "CLIENT_CREDENTIALS"
            }
        
    }
};

const production = {
    endpoints: {
        customerApplications: 'https://d4t3e4y0hc.execute-api.us-east-1.amazonaws.com/prod/appmanager/applications/authorized',
        dynatablesBackend: 'https://qpmdm11m1h.execute-api.ap-northeast-1.amazonaws.com/prod'
    },

    // PureCloud assigned name for the premium app
    // This should match the integration type name of the Premium App
    integrationType: "premium-app-dynatables",

    // Default Values for fail-safe/testing. Shouldn't have to be changed since the app
    // must be able to determine the environment from the query parameter 
    // of the integration's URL
    defaultPcEnv: "usw2.pure.cloud",
    defaultLangTag: "en-us",
    clientId: "55605dc9-7aa2-4e49-809a-d93b7b35f51d", // US WEST

    // Permissions required for running the Wizard App
    setupPermissionsRequired: ['admin'],

    // Application name
    appName: "Callflow Data Service",
    // URL of the Callflow Data Service application
    appUrl: "https://callflowdataservice.genesysinnoapps.com/",
    
    // These are the PureCloud items that will be added and provisioned by the wizard
    provisioningInfo: {
        "role": 
            {
                "name": "Role",
                "description": "Generated role for access to the app.",
                "permissionPolicies": [
                    {
                        "domain": "integration",
                        "entityName": "callflowDataService",
                        "actionSet": ["view"],
                        "allowConditions": false
                    },
                    {
                        "domain": "integrations",
                        "entityName": "integration",
                        "actionSet": ["view"],
                        "allowConditions": false
                    }
                ]
            }
        ,
        "oauth": 
            {
                "name": "OAuth Client",
                "description": "Generated Client that's passed to the App Backend",
                "roles": ["Role"],
                "authorizedGrantType": "CLIENT_CREDENTIALS"
            }
        
    }

};

const env = process.env.REACT_APP_CUSTOM_ENV.trim();
console.log('env:', env);

var configuration = development;

if(env === 'production')
{
    configuration = production;
}
else if(env === 'test')
{
    configuration = test;
}

console.log('Loading ' + env + ' configuration');

export const config = configuration;
export const maxTableCount = 100;